import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import IASatelite from './pages/IASatelitePage'; 
import { Toaster } from 'react-hot-toast';
import Home from './pages/Home';
import FarmList from './pages/FarmList';
import AddSensorData from './pages/AddSensorData';
import Sensors from './pages/Sensors';
import ViewRecommendation from './pages/ViewRecommendation';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './components/Dashboard';
import Reports from './components/Reports';
import Settings from './components/Settings';
import FarmData from './components/FarmData';
import FarmDetails from './pages/FarmDetails';
import HarvestHistory from './pages/HarvestHistory';
import StockControl from './pages/StockControl';


import { auth } from './firebase';
import PrivateLayout from './components/PrivateLayout';

// Componente de rota privada usando Outlet
const PrivateRoute = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return <div>Carregando...</div>;
  return user ? <Outlet /> : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Router>
      <CssBaseline />
       {/* Toaster global para mostrar os snackbars */}
       <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Navigate to="/login" />} />

        {/* Rotas privadas com layout aplicado em grupo */}
        <Route element={<PrivateRoute />}>
          <Route element={<PrivateLayout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/sensors" element={<Sensors />} />
            <Route path="/add-sensor" element={<AddSensorData />} />
            <Route path="/analise-satelite" element={<IASatelite />} />
            <Route path="/recommendations" element={<ViewRecommendation />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/farm-data" element={<FarmData />} />
            <Route path="/farm-list" element={<FarmList />} />
            <Route path="/farm/:id" element={<FarmDetails />} />
            <Route path="/harvest-history" element={<HarvestHistory />} />
            <Route path="/stock-control" element={<StockControl />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
